import { CarrierCodeType, PackageType } from '@/features/shipment/types';

export interface Widget {
  size: 'big' | 'small',
  show: boolean,
  name: string,
  position: number,
  itemsShown?: number,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customSettings?: any,
}

export interface RecentShipment {
  packageType: keyof typeof PackageType,
  packageCount: number,
  status: string,
  lastScan?: string,
  CarrierTrackingNo?: string,
  carrierCode: keyof typeof CarrierCodeType,
  serviceSelected: string,
  serviceName: string,
  trackingNo: string,
  toAddress: {
    company: string,
    contact: string,
    addr1: string,
    postalCode: string,
    city: string,
  },
}

export interface RecentShipments extends Widget {
  shipments?: Array<RecentShipment>,
}

export interface ScheduledPickup {
  pickupDate: string,
  carrierCode: string,
  selectedService?: string,
  requestNumber: string,
  closeTime: string,
  readyTime: string,
  fromAddress: {
    addr1: string,
    city: string,
    company: string,
    contact: string,
    postalCode: string,
  },
}

export interface ScheduledPickupsWidget extends Widget {
  pickups?: Array<ScheduledPickup>,
}

export interface TopChannel {
  qty: number,
  name: string,
  subname: string,
}

// interface TopChannels extends Widget {
//   channels?: Array<TopChannel>,
// }

export interface Destination {
  countryCode: string,
  countryName: string,
  count: number,
  percentage: number,
}

export interface TopDestinationsWidget extends Widget {
  destinations?: Array<Destination>,
}

export interface Transits {
  created: number,
  intransit: number,
  exception: number,
  delivered: number,
}

export interface TransitStatusWidget extends Widget {
  transits?: Transits,
}

export interface CostBreakdownCarrier {
  carrierCode: string,
  packageCount: number,
  cost: number,
}

export interface CostBreakdownData {
  totalSpend: number,
  totalSavings: number,
  totalSavingsPercentage: number,
  avgSpendPerDay: number,
  avgSpendPerShipment: number,
  avgSpendPerPackage: number,
  avgPackageCountPerDay: number,
  totalPackageCount: number,
  breakdownPerCarrier: Array<CostBreakdownCarrier>
}

export interface CostBreakdownWidget extends Widget {
  data: CostBreakdownData
}

export enum CostBreakdownDataType {
  Shipping = 'Shipping',
  Billing = 'Billing'
}

export interface Widgets {
  howItWorks: Widget,
  recentShipments: RecentShipments,
  scheduledPickups: ScheduledPickupsWidget,
  shippingTips: Widget,
  transitStatus: TransitStatusWidget,
  costBreakdown: CostBreakdownWidget,
  // topChannels: TopChannels,
  topDestinations: TopDestinationsWidget,
}

export interface WidgetSettings {
  dashboardWidget: string,
  itemsShown?: number,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customSettings?: any,
  visible?: boolean,
  position?: number,
}

export interface DashboardSettings {
  firstname: string,
  hasShipped: boolean,
  timeOfDay: string,
  settings?: Array<WidgetSettings>,
  order?: {
    big: string[],
    small: string[],
  }
}

interface Dashboard {
  widgets: Widgets,
  dashboardSettings: DashboardSettings,
  isDashboardSettings: number,
  showCustomizeTooltip: boolean,
  customizeTooltipStep: number,
}

export default Dashboard;
